export default "__VITE_ASSET__CUzeFteF__"